import { TIMELINE_MAX_HEIGHT } from "Order/Widgets/OrderTimelineWidget";
import { motion } from "motion/react";
import type { ReactNode } from "react";
import { useEffect } from "react";

interface ExpandTimelineAnimationProps {
	children: ReactNode;
	isExpanded: boolean;
	componentRef: React.RefObject<HTMLDivElement>;
	contentHeight: number;
	setContentHeight: React.Dispatch<React.SetStateAction<number>>;
}

export const ExpandTimelineAnimation = ({
	children,
	isExpanded,
	componentRef,
	contentHeight,
	setContentHeight,
}: ExpandTimelineAnimationProps) => {
	useEffect(() => {
		if (componentRef.current) {
			setContentHeight(componentRef.current.scrollHeight);
		}
	}, [children]);

	const collapsedHeight =
		contentHeight < TIMELINE_MAX_HEIGHT ? "auto" : TIMELINE_MAX_HEIGHT;

	return (
		<motion.div
			animate={{ height: isExpanded ? contentHeight : collapsedHeight }}
			initial={false}
			transition={{ duration: 0.4, ease: "easeInOut" }}
			style={{ overflowY: isExpanded ? "visible" : "hidden" }}
		>
			{children}
		</motion.div>
	);
};
